module.exports = ".custom-application-lookup>.ng-select-disabled::ng-deep .ng-value-label {\n    color: black !important;\n}"